export default __webpack_public_path__ + "static/bg-group-bookings-0d0413e722d2368d4e7985e47764e589.jpg";